module.exports = flarum.core.compat['common/utils/humanTime'];